module.exports = __webpack_public_path__ + "img/salvia.8e88e93c.png";